type WebSocketConstructor = new (url: string, protocols?: string | string[]) => WebSocket;

/**
 * Get a WebSocket constructor: custom → globalThis → throw.
 * In Node.js, users should either install 'ws' or pass the constructor explicitly.
 */
export function getWebSocketConstructor(custom?: unknown): WebSocketConstructor {
  if (custom) {
    return custom as WebSocketConstructor;
  }
  if (typeof globalThis !== 'undefined' && typeof globalThis.WebSocket !== 'undefined') {
    return globalThis.WebSocket as unknown as WebSocketConstructor;
  }
  throw new Error(
    'WebSocket not available. Install the "ws" package or provide a WebSocket constructor in options.',
  );
}

/** Encode string to Uint8Array (UTF-8). */
export function encodeText(s: string): Uint8Array {
  if (typeof TextEncoder !== 'undefined') {
    return new TextEncoder().encode(s);
  }
  // Node.js fallback
  return Buffer.from(s, 'utf-8');
}

/** Decode Uint8Array to string (UTF-8). */
export function decodeText(data: Uint8Array): string {
  if (typeof TextDecoder !== 'undefined') {
    return new TextDecoder().decode(data);
  }
  return Buffer.from(data).toString('utf-8');
}

/** Base64 encode bytes. */
export function base64Encode(data: Uint8Array): string {
  if (typeof Buffer !== 'undefined') {
    return Buffer.from(data).toString('base64');
  }
  let binary = '';
  for (let i = 0; i < data.length; i++) {
    binary += String.fromCharCode(data[i]);
  }
  return btoa(binary);
}

/** Base64 decode string to bytes. */
export function base64Decode(s: string): Uint8Array {
  if (typeof Buffer !== 'undefined') {
    return new Uint8Array(Buffer.from(s, 'base64'));
  }
  const binary = atob(s);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes;
}
